/** Editor i18n catalog: availability (spec #304). English is the key source; German uses "du" and real umlauts. */
import { defineMessages } from "../core.ts";

export const availability = defineMessages(
  {
    loading: "Loading availability…",
    title: "Availability",
    edit: "Edit",
    no_hours: "No hours set yet",
    off: "Off",
    from_aria: "{day} from",
    until_aria: "{day} until",
    err_from_before_until: "{day}: from must be before until",
    err_save: "Could not save your availability. Check the times and try again.",
    timezone: "Timezone",
    city: "City",
    country: "Country",
    channel: "Preferred channel",
    channel_none: "None",
    telegram_hint: "Link Telegram from the dealer bot to pick it here.",
    goal: "Weekly card goal",
    goal_low: "0-7 cards / week",
    goal_high: "7+ cards / week",
    not_set: "Not set",
    save: "Save",
    cancel: "Cancel",
  },
  {
    loading: "Verfügbarkeit wird geladen…",
    title: "Verfügbarkeit",
    edit: "Bearbeiten",
    no_hours: "Noch keine Zeiten eingetragen",
    off: "Aus",
    from_aria: "{day} ab",
    until_aria: "{day} bis",
    err_from_before_until: "{day}: Der Beginn muss vor dem Ende liegen",
    err_save: "Deine Verfügbarkeit konnte nicht gespeichert werden. Prüf die Zeiten und versuch es nochmal.",
    timezone: "Zeitzone",
    city: "Stadt",
    country: "Land",
    channel: "Bevorzugter Kanal",
    channel_none: "Keiner",
    telegram_hint: "Verbinde Telegram über den Dealer-Bot, um es hier auszuwählen.",
    goal: "Wöchentliches Card-Ziel",
    goal_low: "0-7 Cards / Woche",
    goal_high: "7+ Cards / Woche",
    not_set: "Nicht festgelegt",
    save: "Speichern",
    cancel: "Abbrechen",
  },
);
